'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ImageModal = _react2['default'].createClass({
    displayName: 'ImageModal',


    propTypes: {
        'imagePath': _react2['default'].PropTypes.string
    },

    componentDidMount: function componentDidMount() {
        if (process.env.NODE_ENV !== 'test') {
            $(document).foundation();
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
        if (process.env.NODE_ENV !== 'test') {
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    render: function render() {
        return _react2['default'].createElement('img', { src: this.props.imagePath });
    }
});

module.exports = ImageModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/image-modal.jsx
 ** module id = 871
 ** module chunks = 0
 **/